export default __webpack_public_path__ + "static/media/mine.2db55e6a.png";